import { Cta, Reassurance } from './Cta'

export function Hero() {
  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="hero-grid">
        <div className="hero-copy">
          <h1 id="hero-title">
            <span>Exceptional South African</span>{' '}
            <span>finance talent. Ready to</span>{' '}
            <span>strengthen your team.</span>
          </h1>
          <p className="hero-lead">
            Ark Solutions connects international accounting and audit firms with
            qualified South African CA(SA) professionals who work remotely as
            dedicated members of their teams.
          </p>
          <p className="hero-secondary">
            We employ and support the professional locally, so you can grow
            without establishing a South African employment operation.
          </p>
          <div className="hero-actions">
            <Cta>Explore your talent requirements</Cta>
            <Reassurance />
          </div>
        </div>
        <div
          className="hero-media"
          aria-label="A diverse team of South African finance professionals collaborating in Cape Town"
        >
          <img
            src="/assets/ark-solutions-hero.png"
            alt="A Black African, Indian South African and white South African finance professional collaborating around a laptop in a Cape Town office"
            width="1604"
            height="980"
            fetchPriority="high"
          />
        </div>
      </div>
      <svg
        className="hero-arc"
        viewBox="0 0 1100 280"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M-30 252C202 16 541 16 1140 200"
          stroke="var(--blue)"
          strokeWidth="5"
          strokeLinecap="round"
        />
        <circle cx="286" cy="93" r="12" fill="#ff6853" />
        <circle
          cx="791"
          cy="106"
          r="12"
          fill="#fff"
          stroke="var(--blue)"
          strokeWidth="4"
        />
      </svg>
    </section>
  )
}
